/**
 * Keyboard navigation helpers for the radio group's roving tabindex.
 *
 * Arrow keys move focus between items (without selecting); these functions pick
 * which item receives focus, skipping disabled ones and wrapping around.
 */

/**
 * Index of the next enabled item, stepping from `from` by `delta` (+1 / -1),
 * wrapping around and skipping disabled items. Returns `from` when it is the
 * only enabled item, or -1 when the list is empty or all items are disabled.
 */
export function nextEnabledIndex(disabled: boolean[], from: number, delta: number): number {
  const n = disabled.length;
  if (n === 0) return -1;
  for (let step = 1; step <= n; step++) {
    const i = (((from + delta * step) % n) + n) % n;
    if (!disabled[i]) return i;
  }
  return from >= 0 && from < n && !disabled[from] ? from : -1;
}

/** Index of the first enabled item, or -1 if none. */
export function firstEnabledIndex(disabled: boolean[]): number {
  return nextEnabledIndex(disabled, -1, 1);
}

/** Index of the last enabled item, or -1 if none. */
export function lastEnabledIndex(disabled: boolean[]): number {
  return nextEnabledIndex(disabled, 0, -1);
}
